import React from 'react';
import TextField from "@material-ui/core/TextField";

const MaskedText = props => {
  let labelProps = {...props.inputLabelProps};
  let shrink = props.shrink; 
  if (props.label && (props.value || props.shrink)) {
    labelProps = {shrink: true}
    shrink = true;
  }
  let inputProps = {...props.inputProps};
  let classNames = Array.isArray(props.className)?[...props.className]:[props.className]
  if (props.readOnly) {
    inputProps.readOnly = true; 
    if (Array.isArray(inputProps.className)){
      inputProps.className = [...inputProps.className, 'readOnly'].join(' ');
    } else {
      inputProps.className = [inputProps.className, 'readOnly'].join(' ');
    }
    classNames.push('readonly');
  }
  const className = classNames.join(' ');

  return (
    <TextField
      id={props.id}
      label={props.label}
      className={className}
      multiline={true}
      readOnly={props.readOnly}
      //shrink={shrink}
      InputProps={{...inputProps}}
      InputLabelProps={{...labelProps}}
      fullWidth
      onChange={props.onChange}
      style={{width: "100%", ...props.style}}
      value={props.value}
    />
  )
};

export default MaskedText;